// Sweetalert mixin
const SwalBootstrap = Swal.mixin({
    buttonsStyling: false,
    scrollbarPadding: false,
    customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-muted',
    },
});

// Set data attribute of element
$.fn.setDataAttribute = function (key, value) {
    $(this).data(key, value).attr('data-' + key, value);

    return $(this);
}

// String slugify
String.prototype.slugify = function () {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return this.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

// String match wildcard selectors
String.prototype.wildcardMatch = function (rule) {
    const s = this;
    const regex = (s) => s.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");

    return new RegExp('^' + rule.split('*').map(regex).join('.*') + '$').test(s);
}

// Show the default loader box
$.showLoader = function () {
    SwalBootstrap.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        html: `<div class="inline-preloader">
            <div class="loader">
                <img src="/images/logo/logo.svg" />
                <div class="rings">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>`,
    });
}

// Parse numeric value into comma saperated decimal
$.formatNumber = function (amount, decimal = 2, saperator = true) {
    amount = parseFloat(amount || 0);

    if (!isNaN(amount)) {
        amount = amount.toFixed(decimal);
    }

    if (saperator) {
        amount = amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    return amount;
}

// Parse comma saperated decimal into numeric value
$.parseNumber = function (amount) {
    if (amount instanceof String) {
        amount = amount.replaceAll(',', '');
    }

    amount = parseFloat(amount);
    if (!isNaN(amount)) {
        return amount;
    }
}

// Initialize cleave.js with fixed decimals for currency
$.initAsCurrencyAmountInput = function (input) {
    new Cleave(input, {
        numeral: true,
        numeralDecimalScale: 2,
        numeralPositiveOnly: true,
        numeralThousandsGroupStyle: 'thousand',
    });

    $(document).on('change', input, function () {
        $(this).val($.formatNumber($.parseNumber($(this).val())));
    });
}

// Map key-value pairs from collection
$.mapKeyValueFromCollection = function (collection = [], key = null, value) {
    return collection.reduce((output, item, index) => {
        output[item[key] || index] = item[value];
        return output;
    }, {});
}

// Pluck value for input badge
$.pickKeyValueFromCollection = function (collection, keys) {
    return Object.keys(collection)
        .filter(key => keys.includes(key))
        .reduce((carry, key) => {
            carry.push({
                [key]: collection[key],
            });

            return carry;
        }, []);
}

// Update object value by dot anotation key
$.updateObjectValueByKey = function (object, key, value) {
    var keys = key.split('.'),
        current = object;

    for (var i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
            current[keys[i]] = {};
        }

        current = current[keys[i]];
    }

    current[keys[keys.length - 1]] = value;
}

// Smooth scroll to specific position
$.scrollTo = function (position, target = 'html, body', duration = 0) {
    $(target).animate({
        scrollTop: position,
    }, duration);
}

// Redirect or reload to specific page
$.redirectTo = function (url) {
    window.location.href = url;
    if (/(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,})(\b|\r)/.test(url)) {
        window.location.reload();
    }
}

// Initialize download process
$.initDownload = function (route, interval = 500) {
    $.showLoader();
    var processId = Math.random().toString(36).substring(7),
        url = new URL(route),
        params = new URLSearchParams(url.search);

    params.set('processId', processId);
    window.location.href = url.origin + url.pathname + '?' + params.toString();

    var interval = setInterval(() => {
        $.ajax({
            type: 'POST',
            url: url.origin + url.pathname + '/status',
            beforeSend: function () { },
            success: function (e) {
                if (e.data.lastProcessed == processId) {
                    $.handleSuccess(e);
                    clearInterval(interval);
                }
            },
            error: function (e) {
                $.handleError(e);
            },
        });
    }, interval);
}

// Popup new window with settings
$.popupTo = function (url, title) {
    var width = 1024;
    var height = 768;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);

    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
}

// Initialize popup transaction
$.initPopupTransaction = function (url, title, onClose = () => { }) {
    var window = $.popupTo(url, title);
    var interval = setInterval(() => {
        if (window.closed) {
            onClose();
            clearInterval(interval);
            $('.popup-transaction-loader').hide();
        }
    }, 500);

    $('.popup-transaction-loader').css('display', 'flex');
}

// Sleep timeout
$.sleep = function (duration) {
    return new Promise(resolve => setTimeout(resolve, duration));
}

// Get plugins' values
$.getPluginValue = async function (input, plugin) {
    while (!input.data(plugin) || input.data(plugin).initialized === false) {
        await $.sleep(250);
        console.log('waiting', !input.data(plugin));
    }

    switch (plugin) {
        default:
            return input.data(plugin).val();
    }
}

// Set plugins' values
$.setPluginValue = async function (input, plugin, value) {
    while (!input.data(plugin) || input.data(plugin).initialized === false) {
        await $.sleep(250);
        console.log('waiting', !input.data(plugin));
    }

    switch (plugin) {
        case 'daterangepicker':
            input.data(plugin).setStartDate(value);
            input.data(plugin).setEndDate(value);
            break;

        default:
            input.data(plugin).val(value);
    }
}

// Reset input values
$.resetInputValues = function (element, selectors) {
    $(element).find(selectors).not('.ignore').each((index, input) => {
        if (!$(input).parents('.collection').length || ($(input).parents('.collection').length && $(input).parent().closest('.collection').is($(parent)))) {
            // Collections
            if ($(input).data('customCollection')) {
                $(input).data('customCollection').val([]);
            }

            // Selection
            else if ($(input).data('customSelection')) {
                $(input).data('customSelection').val('');
            }

            // Editable Table
            else if ($(input).data('customEditableTable')) {
                $(input).data('customEditableTable').val([]);
            }

            // Selection Table
            else if ($(input).data('customSelectionTable')) {
                $(input).data('customSelectionTable').val([]);
            }

            // Badge inputs
            else if ($(input).data('customBadgeInput')) {
                $(input).data('customBadgeInput').val([]);
            }

            // Phone inputs
            else if ($(input).data('customPhoneInput')) {
                $(input).data('customPhoneInput').val({
                    'country': 'MY',
                    'callingCode': '+60',
                    'rawInput': '',
                }).resetSearch();
            }

            // Rating inputs
            else if ($(input).data('customRatingInput')) {
                $(input).data('customRatingInput').val(0);
            }

            // Daterangepickers

            // Locale inputs

            // Draggable

            // Checkboxes & radios
            else if ($(input).is(':checkbox, :radio')) {
                $(input).prop('checked', false);
            }

            // Select
            else if ($(input).is('select')) {
                $(input).val($(input).find('option:first').val());
            }

            // Others
            else {
                $(input).val('');
            }

            $(input).trigger('change');
        }
    });
}

// Get input values
$.getInputValues = function (element, selectors, parent = null) {
    var object = {};

    $(element).find(selectors).not('.ignore').each((index, input) => {
        if ((!$(input).parents('.collection').length || ($(input).parents('.collection').length && $(input).parent().closest('.collection').is($(parent)))) &&
            (!$(input).parents('.table-editable').length || ($(input).parents('.table-editable').length && $(input).parent().closest('.table-editable').is($(parent))))) {
            // Collections
            if ($(input).data('customCollection')) {
                object[$(input).attr('name')] = $(input).data('customCollection').val();
            }

            // Selection
            else if ($(input).data('customSelection')) {
                object[$(input).attr('name')] = $(input).data('customSelection').val();
            }

            // Editable Table
            else if ($(input).data('customEditableTable')) {
                object[$(input).attr('name')] = $(input).data('customEditableTable').val();
            }

            // Selection Table
            else if ($(input).data('customSelectionTable')) {
                object[$(input).attr('name')] = $(input).data('customSelectionTable').val();
            }

            // Badge inputs
            else if ($(input).data('customBadgeInput')) {
                object[$(input).find('ul').attr('name')] = $(input).data('customBadgeInput').val();
            }

            // Phone inputs
            else if ($(input).data('customPhoneInput')) {
                var phoneInput = $(input).data('customPhoneInput');
                if (phoneInput.isNotEmpty()) {
                    object[phoneInput.$input.attr('name')] = phoneInput.val();
                }
            }

            // Rating inputs
            else if ($(input).data('customRatingInput')) {
                if ($(input).data('customRatingInput').val() > 0) {
                    object[$(input).attr('name')] = $(input).data('customRatingInput').val().toString();
                }
            }

            // Daterangepickers

            // Locale inputs

            // Draggable

            // Checkboxes & radios
            else if ($(input).is(':checkbox, :radio')) {
                if (!$(input).closest('.table-selection').length) {
                    if ($(input).closest('.input-group').length) {
                        object[$(input).closest('.input-group').attr('name')] = $(input).closest('.input-group').find(':checkbox:checked, :radio:checked').map((index, input) => $(input).attr('value')).toArray();
                    } else {
                        object[$(input).attr('name')] = $(input).prop('checked');
                    }
                }
            }

            // Others
            else {
                object[$(input).attr('name')] = $(input).val();
            }
        }
    });

    return object;
}

// Set input values
$.setInputValues = async function (element, selectors, values) {
    var priorityNames = ['country', 'state', 'city'];

    $(element).find(selectors).not('.ignore')
        .sort((a, b) => priorityNames.indexOf($(a).attr('name')) - priorityNames.indexOf($(b).attr('name')))
        .each((index, input) => {
            var attribute = $(input).attr('name'),
                value = values[attribute];

            if ((!$(input).parents('.collection').length || $(element).hasClass('item')) &&
                (!$(input).parents('.table-editable').length || $(element).hasClass('item'))) {
                // Collections
                if ($(input).hasClass('collection') && value) {
                    $.setPluginValue($(input), 'customCollection', value);
                }

                // Selection
                else if ($(input).hasClass('selection') && value) {
                    $.setPluginValue($(input), 'customSelection', value);
                }

                // Editable Table

                // Selection Table

                // Badge inputs
                else if ($(input).hasClass('input-badge')) {
                    value = values[$(input).find('>ul').attr('name')];
                    if (value) {
                        $.setPluginValue($(input), 'customBadgeInput', value);
                    }
                }

                // Phone inputs
                else if ($(input).hasClass('input-phone') && value) {
                    $.setPluginValue($(input), 'customPhoneInput', value);
                }

                // Rating inputs

                // Daterangepickers
                else if ($(input).hasClass('date-range') && value) {
                    $.setPluginValue($(input), 'daterangepicker', value);
                }

                // Locale inputs
                else if (['country', 'state', 'city'].includes(attribute)) {
                    if (attribute == 'country') {
                        $.setPluginValue($(element).find('[name="country"]'), 'customLocaleInput', {
                            country: values['country'],
                            state: values['state'],
                            city: values['city'],
                        });
                    }

                    return;
                }

                // Checkboxes & radios
                else if ($(input).is(':checkbox, :radio')) {
                    if ($(input).closest('.input-group').length) {
                        values[$(input).closest('.input-group').attr('name')].forEach(value => {
                            $(input).closest('.input-group').find(`[name="${value}"]`).prop('checked', true);
                        });
                    } else {
                        $(input).prop('checked', value);
                    }
                }

                // Others
                else if (value) {
                    $(input).val(value);
                }

                $(input).trigger('change');
            }
        });
}

// Focus input based on event errors
$.focusOnError = function (e) {
    if (e.responseJSON.errors !== undefined) {
        $('input[name*="password"]').val('');
        $('[name="' + Object.keys(e.responseJSON.errors)[0] + '"]').trigger('focus');
    }
}

// Handle HTTP success responses
$.handleSuccess = function (e, onClose = () => { }) {
    SwalBootstrap.fire({
        didClose: onClose,
        icon: 'success',
        showConfirmButton: false,
        text: e.data.message,
        timer: 2000,
        title: 'Success.',
    });
}

// Handle HTTP error responses
$.handleError = function (e, onClose = () => { }) {
    switch (e.status) {
        case 500:
            SwalBootstrap.fire({
                icon: 'error',
                text: 'We have encountered an unexpected error. Kindly contact the site developer for more details.',
                title: 'Unexpected Error.',
                didClose: () => {
                    // window.location.reload();
                },
            });
            break;

        case 401:
        case 403:
            SwalBootstrap.fire({
                icon: 'error',
                text: 'Your action is unauthorized. Kindly try again using the correct account with the relevant privilege.',
                title: 'Unauthorized Action.',
                didClose: onClose,
            });
            break;

        case 422:
            SwalBootstrap.fire({
                icon: 'error',
                text: e.responseJSON.errors[Object.keys(e.responseJSON.errors)[0]][0],
                title: 'Invalid Request.',
                didClose: onClose,
            });
            break;

        default:
            SwalBootstrap.fire({
                icon: 'error',
                text: e.responseJSON.message,
                title: 'Error.',
                didClose: onClose,
            });
    }
}

// Prompt Confirmation
$.promptConfirmation = function (message, onConfirm = () => { }, onCancel = () => { }) {
    SwalBootstrap.fire({
        confirmButtonText: 'Confirm',
        icon: 'warning',
        showCancelButton: true,
        text: message,
        title: 'Confirmation',
    }).then((result) => {
        result.value ? onConfirm() : onCancel();
    });
}

// Set Cookies
$.setCookie = function (cname, cvalue, exdays = 365) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

// Get Cookies
$.getCookie = function (cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return '';
}

// Set Session Storage
$.setSessionStorage = function (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
}

// Get Session Storage
$.getSessionStorage = function (key) {
    var item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
}

// Delete Session Storage
$.deleteSessionStorage = function (key) {
    sessionStorage.removeItem(key);
}
